// import { jsonFetch } from '../client/api/api';

// let customCard;
// let swiperSlideParent;
// let swiperShortcodeGame = null;
// let savedCustomSlideContent = null;  // Sauvegarde du contenu de la slide custom

// //for the shortcode filters
// document.addEventListener('DOMContentLoaded', function() {

//     let categoryTabs = document.querySelectorAll('.shortcode-games .categories-tabs > .category-tab')
//     let tagTabs = document.querySelectorAll('.shortcode-games .tags-list > .tag-checkbox')
//     let ageTabs = document.querySelectorAll('.shortcode-games .ages-list > .age-checkbox')
//     let gameList = document.getElementById('games-shortcode-list')

//     let category = 'all-games' // Valeur par défaut

//     categoryTabs.forEach(function(tab) {
//         tab.addEventListener('click', function() {
//             categoryTabs.forEach(function(tab) {
//                 tab.classList.remove('active')
//             })
//             this.classList.add('active')
//             category = this.dataset.category
//             updateGames()
//         });
//     })

//     tagTabs.forEach(function(tab) {
//         tab.addEventListener('click', updateGames);
//     })

//     ageTabs.forEach(function(age) {
//         age.addEventListener('click', updateGames);
//     })

//     // Functions to update the games list
//     async function updateGames() {

//         // Add loading
//         let gameCards = document.querySelectorAll('.game-card');
//         let loading = document.getElementById('loading');
//         let btnAllGames = document.getElementById('home-all-games');
        
//         gameCards?.forEach(card => {
//             card.classList.add('loading');
//         });
//         loading?.classList.remove('hidden');
//         loading?.classList.add('show');
//         // End add loading

//         let cat = 'all-games'; 

//         categoryTabs.forEach(function(tab) {
//             if (tab.classList.contains('active')) {
//                 cat = tab.dataset.category
//             }
//         })

//         let tags = []
//         tagTabs.forEach(function(tab) {
//             if (tab.checked) {
//                 tags.push(tab.dataset.tag)
//             }
//         })

//         let ages = []
//         ageTabs.forEach(function(tab) {
//             if (tab.checked) {
//                 ages.push(tab.dataset.age)
//             }
//         })

//         let params = new FormData()
//         params.append('action', 'filter_games')
//         params.append('category', cat)
//         params.append('tags', tags)
//         params.append('ages', ages)
        
//         const response = await jsonFetch(kreenoot_child.ajax_url, {
//             method: "POST",
//             body: params,
//         });

//         // Ajoute ce code pour simuler un délai de la requête AJAX (DEBUG)
//         // await new Promise(resolve => setTimeout(resolve, 2000));
    
//         // Remove loading
//         gameCards.forEach(card => {
//             card.classList.remove('loading');
//         });
//         loading?.classList.remove('show');
//         loading?.classList.add('hidden');
//         // End remove loading

//         if (response.success) {
//             let shortcodeList = document.getElementById('games-shortcode');
//             shortcodeList.innerHTML = response.data;

//             // Détruire l'instance existante de Swiper si elle existe
//             if (swiperShortcodeGame) {
//                 swiperShortcodeGame.destroy(true, true);
//             }

//             // Utiliser setTimeout pour donner le temps au DOM d'assimiler les nouvelles diapositives
//             setTimeout(function(){
//                 // Réinitialiser Swiper avec le nouveau contenu
//                 swiperShortcodeGame = new Swiper("#games-shortcode", {
//                     slidesPerView: 1,
//                     spaceBetween: 10,
//                     navigation: {
//                         nextEl: ".shortcode-game-button-next",
//                         prevEl: ".shortcode-game-button-prev",
//                     },
//                     breakpoints: {
//                         991: {
//                             slidesPerView: 2,
//                         },
//                         1200: {
//                             slidesPerView: 3,
//                         },
//                     }
//                 });
//             }, 0);

//         } else {
//             console.log(response.data)
//         }
//     }
// });

// // Add highlight bar to games filters in the shortcode (+ game list update)
// document.addEventListener("DOMContentLoaded", function() {
//     var categoryTabs = document.querySelectorAll('.category-tab');
//     var highlightBar = document.querySelector('.highlight-bar');
//     var tabsContainer = document.querySelector('.categories-tabs');

//     function moveHighlight(tab) {
//         var leftPos = tab.getBoundingClientRect().left - tabsContainer.getBoundingClientRect().left;
//         var width = tab.offsetWidth;
//         highlightBar.style.left = leftPos + 'px';
//         highlightBar.style.width = width + 'px';
//     }

//     // Move the highlight to the initial active tab
//     var activeTab = document.querySelector('.category-tab.active');
//     if(activeTab) {
//         moveHighlight(activeTab);
//     }

//     categoryTabs?.forEach(function(tab) {
//         tab.addEventListener('mouseover', function() {
//             moveHighlight(this);
//         });
//     });

//     // Move the highlight back to the active tab when not hovering over a tab
//     tabsContainer?.addEventListener('mouseout', function(e) {
//         if (!e.relatedTarget || !tabsContainer.contains(e.relatedTarget)) {
//             // Find the current active tab and move the highlight to it
//             var activeTab = document.querySelector('.category-tab.active');
//             moveHighlight(activeTab);
//         }
//     });
// });

// // Fonction pour gérer l'ajout/la suppression de la card custom
// function manageCustomCard() {
//     var sliderElement = document.querySelector("#games-shortcode .swiper-wrapper");
//     let customSlide = document.querySelector('.custom-card-slide');

//     let cat = 'all-games'; 
//     let categoryTabs = document.querySelectorAll('[data-category]'); // Assurez-vous d'avoir une manière de sélectionner tous vos onglets de catégorie. 

//     categoryTabs.forEach(function(tab) {
//         if (tab.classList.contains('active')) {
//             cat = tab.dataset.category;
//         }
//     });

//     if (cat !== 'all-games' && customSlide) {
//         customSlide.remove(); // Suppression de la slide
//     } else if (cat === 'all-games') {
//         if (window.innerWidth <= 992 && customSlide) {
//             savedCustomSlideContent = customSlide.innerHTML; // Sauvegarde du contenu
//             customSlide.remove(); // Suppression de la slide
//         } else if (window.innerWidth > 992 && !customSlide && savedCustomSlideContent) {
//             // Recréez la slide si elle n'existe pas et que vous êtes sur un grand écran
//             let newSlide = document.createElement('div');
//             newSlide.className = 'swiper-slide custom-card-slide';

//             // Utilisez le contenu sauvegardé pour recréer la slide
//             newSlide.innerHTML = savedCustomSlideContent;

//             // Ajoutez la nouvelle slide à la fin de #games-shortcode
//             sliderElement.appendChild(newSlide);
//         }
//     }

//     if (swiperShortcodeGame) {
//         swiperShortcodeGame.update(); // Mettez à jour le Swiper après avoir ajouté ou supprimé une slide
//     }
// }



// // Fonction pour initialiser le Swiper
// function initSwiper() {
//     var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

//     if (screenWidth <= 991 && !swiperShortcodeGame) {
//         swiperShortcodeGame = new Swiper("#games-shortcode", {
//             slidesPerView: 1,
//             spaceBetween: 10,
//             navigation: {
//                 nextEl: ".shortcode-game-button-next",
//                 prevEl: ".shortcode-game-button-prev",
//             },
//             breakpoints: {
//                 991: {
//                     slidesPerView: 2,
//                 },
//                 1200: {
//                     slidesPerView: 3,
//                 },
//             },
//             simulateTouch: false
//         });
//     } else if (screenWidth > 991 && swiperShortcodeGame) {
//         swiperShortcodeGame.destroy(true, true);  // Détruit le Swiper
//         swiperShortcodeGame = null;
//     }
    
//     // Gérer la card custom ici
//     manageCustomCard();
// }

// // Ecouteurs d'événements
// document.addEventListener("DOMContentLoaded", function() {
//     initSwiper();
// });

// window.addEventListener("resize", function() {
//     initSwiper();
// });


document.addEventListener('DOMContentLoaded', function() {

    var swiper = new Swiper("#game-category-shortcode", {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          500: {
            slidesPerView: 1.5,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 0,
          },
          890: {
            slidesPerView: 3.5,
            spaceBetween: 0,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 0,
          },
        },
      });
})